import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ComparisonTables } from './components/ComparisonTables';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingToast } from './components/FloatingToast';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', '950576387884513');
    f.fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=950576387884513&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      noscriptImg.remove();
    };
  }, []);
  return <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4a843] selection:text-[#0a1628]" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductBreakdown data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <ComparisonTables data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <FloatingToast data-id="element-10" />
    </div>;
}